module.exports = __webpack_public_path__ + "img/circle-v.f1195269.svg";